export const getAudioDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const audio = document.createElement("audio");
    audio.preload = "metadata";

    const objectUrl = URL.createObjectURL(file);
    audio.src = objectUrl;

    audio.addEventListener("loadedmetadata", () => {
      const duration = audio.duration;
      URL.revokeObjectURL(objectUrl);
      resolve(duration);
    });

    audio.addEventListener("error", err => {
      reject(new Error("Error loading audio file"));
    });
  });
};
